export const DEMO_CLOCK = "2026-10-18T18:00:00Z";
export const DAY_START = "2026-10-18T00:00:00Z";

const pad = (n) => String(n).padStart(2, "0");

export function fmtUtc(ts, withDate = false) {
  if (!ts) return "—";
  const d = new Date(ts);
  const hm = `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}Z`;
  return withDate ? `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${hm}` : hm;
}

// Africa/Lagos is UTC+1 all year (WAT), no DST.
export function fmtLagos(ts) {
  if (!ts) return "—";
  const d = new Date(new Date(ts).getTime() + 3600_000);
  return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} WAT`;
}

export const minutesBetween = (a, b) => Math.round((new Date(b) - new Date(a)) / 60000);

export const POLLUTANT_LABEL = { NO2: "NO₂", SO2: "SO₂", PM10: "PM₁₀", PM2_5: "PM₂.₅", CO2: "CO₂" };
export const POLLUTANT_COLOR = { NO2: "#90B849", SO2: "#fbbf24", PM10: "#a78bfa", PM2_5: "#f472b6", CO2: "#34d399" };

export const STATUS_LABEL = {
  PROVISIONAL_SHIP_MATCH: "Provisional ship match",
  MULTIPLE_CANDIDATES: "Multiple candidates",
  NON_SHIP_LIKELY: "Non-ship likely",
  INCONCLUSIVE: "Inconclusive",
};

export const STATE_LABEL = {
  DETECTED: "Detected", TRIAGED: "Triaged", UNDER_REVIEW: "Under review", VERIFIED: "Verified",
  NOT_VERIFIED: "Not verified", INCONCLUSIVE: "Inconclusive", CLOSED: "Closed",
};

export const ROLE_LABEL = { BERTH: "Berth", CHANNEL: "Channel", TERMINAL: "Terminal", BACKGROUND: "Background", RECEPTOR: "Receptor", MET: "Met" };
